export const EMAIL_VALIDATION = 'Email not valid';
export const PASSWORD_REGISTRATION_HINT =
  'Should be at least 6 symbols, contain uppercase, lowercase and one number';
export const PASSWORD_VALIDATION_NUMBER = "Doesn't contain any number";
export const PASSWORD_VALIDATION_UPPERCASE = "Doesn't contain any uppercase";
export const PASSWORD_VALIDATION_LOWERCASE = "Doesn't contain any lowercase";
export const PASSWORD_VALIDATION_LENGTH = 'Less than 6 symbols';
export const PASSWORD_VALIDATION_SPACE = '"space" is not allowed';
export const TEXT_FIELD_IS_REQUIRED = 'This field is required';
export const FULL_NAME_VALIDATION = 'Please enter full name';
export const CARD_NAME_VALIDATION = 'Please enter name from card';
export const URL_VALIDATION = 'Please enter valid url';
export const COUNTRY_VALIDATION = 'Please enter valid country';
export const PASSWORD_CONFIRMATION = 'Passwords don\'t match';
export const TRACKING_PLATFORM_IS_REQUIRED = 'Please, choose Tracking platform';



// WEBPACK FOOTER //
// ./src/utils/messages.js